/**
 * @generated SignedSource<<ca5947f4624bbd958e65c3a9c612803e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type customizerTestDeleteMutation$variables = {
  productID: string;
};
export type customizerTestDeleteMutation$data = {
  readonly deleteProduct: {
    readonly id: string;
  } | null;
};
export type customizerTestDeleteMutation = {
  response: customizerTestDeleteMutation$data;
  variables: customizerTestDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "productID",
        "variableName": "productID"
      }
    ],
    "concreteType": "Model",
    "kind": "LinkedField",
    "name": "deleteProduct",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "customizerTestDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "customizerTestDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cf164ac75e837f2dada37bf2152d2fe2",
    "id": null,
    "metadata": {},
    "name": "customizerTestDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation customizerTestDeleteMutation(\n  $productID: String!\n) {\n  deleteProduct(productID: $productID) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "10acbd1df1baec774dce4e4170b37902";

export default node;
